// @ts-check

import "websocket-polyfill";

/**
 * @param {string} url
 * @param {object} onEvent
 * @param {() => void} onEvent.onOpen
 * @param {(data: string) => void} onEvent.onMessage
 * @param {(event: { code: number, reason: string }) => void} onEvent.onClose
 * @param {() => void} onEvent.onError
 * @returns {{ cleanUp: () => void, sendMessage: (data: string) => void }}
 */
export const createWsImpl = (url, onEvent) => {
  const ws = new WebSocket(url);

  const onOpen = () => {
    onEvent.onOpen();
  };

  /**
   * @param {MessageEvent} event
   * */
  const onMessage = (event) => {
    onEvent.onMessage(event.data);
  };

  /**
   * @param {Event} event
   */
  const onError = (event) => {
    onEvent.onError();
  };

  /**
   * @param {CloseEvent} event
   * */
  const onClose = (event) => {
    onEvent.onClose({
      code: event.code,
      reason: event.reason,
    });
  };

  ws.addEventListener("open", onOpen);
  ws.addEventListener("message", onMessage);
  ws.addEventListener("error", onError);
  ws.addEventListener("close", onClose);

  return {
    cleanUp: () => {
      ws.removeEventListener("open", onOpen);
      ws.removeEventListener("message", onMessage);
      ws.removeEventListener("error", onError);
      ws.removeEventListener("close", onClose);
      ws.close();
    },
    sendMessage: (data) => {
      ws.send(data);
    },
  };
};
